// Shared constants for the affiliate access-status controls
// (EditAffiliates dropdown and the AffiliatesTable inline badge action).
// Colors use the CSS custom properties actually defined by the theme
// (src/theme/linearTheme.js) — NOT the undefined --mui-palette-* vars.

export const AFFILIATE_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'suspended', label: 'Suspended' },
]

export const AFFILIATE_STATUS_MAP = {
  active: {
    bgColor: 'var(--color-success-background)',
    textColor: 'var(--color-success-text)',
    label: 'Active',
  },
  inactive: {
    bgColor: 'var(--color-gray-200)',
    textColor: 'var(--color-text-secondary)',
    label: 'Inactive',
  },
  suspended: {
    bgColor: 'var(--color-error-background)',
    textColor: 'var(--color-error-text)',
    label: 'Suspended',
  },
}

export const PENDING_INVITE_BADGE = {
  bgColor: 'var(--color-warning-background)',
  textColor: 'var(--color-warning-text)',
  label: 'Pending',
}

export const statusConfirmTitle = (status) => `Change affiliate status to "${status}"?`

export const statusConfirmMessage = ({ status, isOwner }) => {
  if (status === 'active') {
    return 'This affiliate will regain access to the system.'
  }
  if (isOwner) {
    return 'This affiliate is an owner of contact groups. Changing status will not remove ' +
      'their ownership but they will not be able to access the system.'
  }
  return 'This affiliate will no longer be able to access the system.'
}
